@if (bookmark && bookmark.guestLink; as guestLink) {
  <p-confirmDialog
    key="bookmarkGuestLinkDisableDialog"
    #cd
    styleClass="w-9"
    appendTo="body"
    [blockScroll]="false">
    <ng-template pTemplate="headless" let-message>
      <div class="p-card border-round pt-1 p-4">
        <app-header
          [icon]="guestLink.enabled ? 'fas fa-link-slash' : 'fas fa-link'"
          [text]="title"></app-header>

        @if (!bookmark || !bookmark.published) {
          @if (guestLink.enabled) {
            Beim deaktivieren des Gast-links, können die Ansichten nicht mehr
            über alte, bereits weitergeleitete Links, aufgerufen werden. <br />
            Der Link kann jeder Zeit wieder aktiviert werden.
          } @else {
            <p>
              Beim aktivieren des Gast-links, können interne Ansichten über von
              externen Nutzer:innen aufgerufen werden.
            </p>

            <app-alert [canToggle]="false" styleClass="p-3">
              <i class="fas fa-circle-exclamation"></i> Achtung: achten Sie
              unbedingt darauf, dass der Link nicht an unbefugte weitergegeben
              wird und deaktivieren Sie Links, die Sie nicht mehr benötigen.
            </app-alert>
          }
        } @else {
          <app-alert [canToggle]="false" styleClass="p-3">
            <i class="fas fa-circle-info"></i>
            "{{ bookmark.title }} ist veröffentlicht und muss nicht über einen
            Gast-Link zur Verfügung gestellt werden."
          </app-alert>
        }

        <p-divider></p-divider>
        <div class="flex align-items-center gap-3 mt-4">
          <button
            [rounded]="true"
            [outlined]="true"
            severity="secondary"
            pButton
            icon="fas fa-times"
            label="nein, abbrechen"
            (click)="cd.reject()"></button>
          <button
            [rounded]="true"
            pButton
            [severity]="bookmark?.guestLink?.enabled ? 'warning' : 'success'"
            icon="fas fa-check"
            [label]="
              bookmark?.guestLink?.enabled
                ? 'ja, deaktivieren'
                : 'ja, aktivieren'
            "
            (click)="cd.accept()"
            class="ml-auto"></button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
}
